import { render, staticRenderFns } from "./RegistrationDisbursementTypePage.vue?vue&type=template&id=62e8e786&scoped=true"
import script from "./RegistrationDisbursementTypePage.vue?vue&type=script&lang=ts"
export * from "./RegistrationDisbursementTypePage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationDisbursementTypePage.vue?vue&type=style&index=0&id=62e8e786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e8e786",
  null
  
)

export default component.exports